import { render } from "./AdminOrderAdvanceEdit.vue?vue&type=template&id=86dea19e&scoped=true&ts=true&lang=true"
import script from "./AdminOrderAdvanceEdit.vue?vue&type=script&lang=ts"
export * from "./AdminOrderAdvanceEdit.vue?vue&type=script&lang=ts"

import "./AdminOrderAdvanceEdit.vue?vue&type=style&index=0&id=86dea19e&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86dea19e"]])

export default __exports__